import {
  subDays,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear
} from "date-fns";

import {
  isMeaningful
} from "@/utils/common";

/**
 * 处理选中日期范围
 * @param dateRange 选中值
 * @returns {{startDateTime: string, endDateTime: string}|Date[]}
 */
function generatorDate(dateRange) {
  if (!isMeaningful(dateRange)) return ['', '']
  let end = new Date()
  let start = new Date()
  switch (dateRange) {
    case 1:
      start = subDays(start, 1)
      break;
    case 2:
      start = subDays(start, 6)
      break
    case 3:
      start = subDays(start, 13)
      break
    case 4:
      start = subDays(start, 29)
      break
    case 5:
      start = subDays(start, 59)
      break
    case 6:
      start = startOfWeek(start)
      end = endOfWeek(end)
      break
    case 7:
      start = startOfMonth(start)
      end = endOfMonth(end)
      break
    case 8:
      start = startOfYear(start)
      break
  }
  return [start, end]
}
/**
 * 处理选中月份
 * @param dateRange 选择值
 * @returns {{startDateTime: string, endDateTime: string}|Date[]}
 */
function generatorMonth(dateRange) {
  if (!isMeaningful(dateRange)) return ['', '']
  let end = new Date()
  let start = new Date()
  switch (dateRange) {
    case 1:
      start.setMonth(start.getMonth() - 1)
      end.setMonth(end.getMonth() - 1)
      break;
    case 2:
      start.setMonth(start.getMonth() - 2)
      break
    case 3:
      start.setMonth(start.getMonth() - 6)
      break
    case 4:
      start = new Date(start.getFullYear(), 0)
      break
  }
  return [start, end]
}
/**
 * 处理选中时间
 * @param dateType 选择时间范围的类型
 * @param dateRange 时间范围
 */
export const generatorTrulyDateTime = (dateType = 'DAY', dateRange = 0) => {
  return dateType === 'DAY' ? generatorDate(dateRange) : generatorMonth(dateRange)
}
/** 日期类型 日/月 */
export const  dateTypeList = [
  {id: 'DAY', text: '日期'},
  {id: 'MONTH', text: '月份'},
]
/** 库存管理用的 */
export const keywordTypeList = [
  {id: 'asin', text: 'ASIN', moreShow: true},
  {id: 'variationAsin', text: '父ASIN', moreShow: true},
  {id: 'sku', text: 'SKU'},
]

export const buildPlatform = {
  methods: {
    buildPlatformCost(row) {
      let platform = [];
      if (!row) {
        return platform;
      }
      let currencySymbol = row.currencySymbol || '';
      let platformItem1 = [{label: '平台费', value: currencySymbol + row.platformCost}];
      let platformItem2 = [];
      if (row.itemTax > 0) {
        platformItem2.push({label: '商品税', value: currencySymbol + row.itemTax})
      }
      if (row.shippingTax > 0) {
        platformItem2.push({label: '运费税', value: currencySymbol + row.shippingTax})
      }
      if (row.codFee > 0) {
        platformItem2.push({label: '货到付款费用', value: currencySymbol + row.codFee})
      }
      if (row.codFeeDiscount > 0) {
        platformItem2.push({label: '货到付款折扣', value: currencySymbol + row.codFeeDiscount})
      }
      if (row.pointsGranted > 0) {
        platformItem2.push({label: '积分', value: currencySymbol + row.pointsGranted})
      }
      platform.push(platformItem1);
      if (platformItem2.length > 0) {
        platform.push(platformItem2);
      }
      return platform;
    }
  }
};


